<article>
  <header>
    <a class="header-logo" href="{{ redirectLink }}">
      <img src="assets/img/universia-red.svg" alt="Logo Universia" />
    </a>
  </header>

  <div
    *ngIf="validKey; else errorTemplate"
    class="unsubscribe-communications-container"
  >
    <unsubscribe-communications
      id="item"
      images='{
        "firstPage": "assets/img/unsubscribe-communications.png",
        "secondPage": "assets/img/icons/susc2x.png"
      }'
      mailingLists="[100]"
      [environment]="env"
      [key]="key"
      [mode]="'async'"
      [buttonsText]="{
        cancel: 'unsubscribe-communications.cancel' | translate,
        unsubscribe: 'unsubscribe-communications.unsubscribe' | translate,
        goTo: 'unsubscribe-communications.goTo' | translate
      }"
      (cancel)="cancelAction()"
      (error)="showError()"
      (goTo)="goTo()"
    >
      <h1 slot="firstPage" class="my-account-h1--dark">
        {{ 'unsubscribe-communications.primaryTitle' | translate }}
      </h1>
      <p
        slot="firstPage"
        class="my-account-primary-paragraph"
        [innerHTML]="
          'unsubscribe-communications.primaryText'
            | translate: { userEmail: userEmail }
        "
      ></p>
      <h1 slot="secondPage" class="my-account-h1--dark">
        {{ 'unsubscribe-communications.secondaryTitle' | translate }}
      </h1>
      <h2 slot="secondPage" class="my-account-h2--light">
        {{ 'unsubscribe-communications.secondarySubtitle' | translate }}
      </h2>
      <p slot="secondPage" class="unsubscribe-communications-space--top-s">
        <span
          [innerHTML]="'unsubscribe-communications.secondaryText' | translate"
          class="my-account-primary-paragraph"
        ></span>
      </p>
      <p
        *ngIf="showCancelationRollbackText"
        slot="secondPage"
        class="unsubscribe-communications-space--top-s"
      >
        <span
          [innerHTML]="
            'unsubscribe-communications.cancelationRollbackText' | translate
          "
          class="my-account-primary-paragraph"
        ></span>
        <a class="my-account-primary-link--m" routerLink="/privacy">
          {{ 'unsubscribe-communications.link' | translate }}
        </a>
      </p>
    </unsubscribe-communications>
  </div>
  <ng-template #errorTemplate>
    <div class="unsubscribe-communications-container error-container">
      <h1 class="my-account-h1--dark">
        {{ 'unsubscribe-communications.errorInput.title' | translate }}
      </h1>
      <p class="my-account-primary-paragraph">
        {{ 'unsubscribe-communications.errorInput.primaryText' | translate }}
      </p>
      <div class="my-account-actions-container">
        <a
          *ngIf="logged"
          class="my-account-primary-button"
          [routerLink]="['../privacy']"
        >
          {{ 'unsubscribe-communications.errorInput.goToPrivacy' | translate }}
        </a>
        <a
          [ngClass]="{
            'my-account-primary-button': !logged,
            'my-account-primary-link--m': logged
          }"
          (click)="cancelAction()"
        >
          <em *ngIf="logged" class="fas fa-arrow-left"></em>
          <span>{{
            'unsubscribe-communications.errorInput.goToUniversia' | translate
          }}</span>
        </a>
      </div>
    </div>
  </ng-template>
</article>
